export const ACCORDION_ITEM_SELECTOR = '.c-accordion-item';
export const ACCORDION_BUTTON_SELECTOR = '.c-accordion-item__button';
export const CONTENT_HEIGHT_VAR = '--content-height';
